import React from "react";
import { Link } from "react-router-dom";

export default function TemplateRow({ item, unit, displayNo }) {
  return (
    <div className="cc-unit-template-row">
      <div className="cc-unit-template-col-no">{displayNo}</div>

      <div className="cc-unit-template-col-title">
        <Link
          to={`/cc/${unit}/${item.id}`}
          state={{ activeTab: "template" }}
          className="cc-unit-template-title-link"
        >
          {item.title}
        </Link>
      </div>

      <div className="cc-unit-template-col-meta">
        <div className="cc-unit-template-col-writer">{item.writer}</div>
        <div className="cc-unit-template-col-date">{item.date}</div>
        <div className="cc-unit-template-col-view">{item.view}</div>
      </div>
    </div>
  );
}